import { memo } from 'react';
import { Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { getExandSideInputStatus, handleExpandSideInput } from 'redux/BuilderModeSlice';
import { AppDispatch } from 'utils/GlobalHelpers';

import { BUILDER_MODE_V1_LAYOUT } from '../../constants';

import InputPanelDimensionSettingsV1 from './InputPanelDimensionSettingsV1';
import InputPanelExpandedViewButtonV1 from './InputPanelExpandedViewButtonV1';

export interface InputPanelTableToolbarV1Properties {
  indicatorId: number;
  isRefreshing?: boolean;
  refetchRequest: () => void;
}

const InputPanelTableToolbarV1 = memo(
  ({ indicatorId, isRefreshing = false, refetchRequest }: InputPanelTableToolbarV1Properties) => {
    const dispatch = useDispatch<AppDispatch>();
    const isExpanded = useSelector(getExandSideInputStatus);

    return (
      <Flex
        align='center'
        justify='space-between'
        w='100%'
        gap={BUILDER_MODE_V1_LAYOUT.inputPanelTableToolbarGap}
        flexShrink={0}
      >
        <InputPanelExpandedViewButtonV1
          isExpanded={isExpanded}
          onClick={() => dispatch(handleExpandSideInput(!isExpanded))}
        />
        <InputPanelDimensionSettingsV1
          indicatorId={indicatorId}
          isRefreshing={isRefreshing}
          refetchRequest={refetchRequest}
        />
      </Flex>
    );
  },
);

InputPanelTableToolbarV1.displayName = 'InputPanelTableToolbarV1';

export default InputPanelTableToolbarV1;
